import styled from 'styled-components';
import { Layout } from '@/ui';
import { COLORS, DEVICES, SHADOWS } from '@/theme';

export const StyledLayout = styled(Layout)`
  &.ant-layout {
    min-height: 100vh;
    background-color: ${COLORS.BG_SECONDARY};
  }
`;
export const StyledContainer = styled.div`
  display: flex;
  height: 100vh;
  position: relative;
  background: url('/images/bg_pattern.png') repeat ${COLORS.DARK_GREEN};
`;

export const StyledContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  margin-inline: 6.5rem auto;
  width: 100%;
  max-width: 50rem;

  @media screen and ${DEVICES.LAPTOP_M} {
    max-width: 72rem;
  }
`;

export const StyledLoginBox = styled.div`
  width: 400px;
  padding: 1.5rem;
  background: ${COLORS.WHITE};
  box-shadow: ${SHADOWS.LIGHT};
  border-radius: 0.5rem;
  z-index: 3;
`;

export const StyledRobotImage = styled.div`
  display: none;

  @media screen and ${DEVICES.LAPTOP} {
    display: block;
    background: url('/images/robot.png') left bottom / 30rem no-repeat;
    width: 40rem;
    height: 100%;
    position: absolute;
    z-index: 2;
    right: 4vw;
  }

  @media screen and ${DEVICES.DESKTOP_S} {
    right: 13vw;
  }
`;
